module.exports = __webpack_public_path__ + "img/logo.064e23fd.png";